import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  root: {
    height: 35,
    display: 'flex',
    borderRadius: 5,
    alignItems: 'center',
    marginLeft: theme.spacing(1),
    padding: `0 ${theme.spacing(1)}px`,
    backgroundColor: `${theme.palette.tertiary.light}50`,
  },
  icon: {
    fontSize: 18,
    marginRight: theme.spacing(0.5),
    fill: theme.palette.tertiary.main,
    color: theme.palette.tertiary.main,
  },
})

const GraphLineLabel = ({
  classes, className, text, icon: Icon
}) => (
  <div className={classNames(classes.root, className)}>
    <Icon className={classes.icon} />
    <Typography>{text}</Typography>
  </div>
)

GraphLineLabel.propTypes = {
  icon: PropTypes.any,
  text: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
}

export default withStyles(styles)(GraphLineLabel)



// WEBPACK FOOTER //
// ./src/components/atoms/GraphLineLabel.js